import $http from '../utils/http'

const originalBillEntry = {
    // 查询自动同步配置 = > 账单存储桶配置分页查询
    selectBilldataSourceConfig(params){
        return $http.post(`${global.API_URL}/sme/billDataSourceConfig/selectBilldataSourceConfig`,params)
    },
    // 查询手动同步配置 =》上传账单分页查询
    selectUpLoadBilldataSourceConfig(params){
        return $http.post(`${global.API_URL}/sme/billDataSourceConfig/selectUpLoadBilldataSourceConfig`,params)
    },
    // 配置自动账单 =》 账单存储桶配置 配置按钮 弹窗保存接口
    createBillDataSourceConfig(params){
        return $http.post(`${global.API_URL}/sme/billDataSourceConfig/billDataSourceConfig`,params)
    },
    // 手动同步配置 => 上传账单 上传按钮 弹窗保存接口
    uploadBillDataSourceConfigConfirm(params){
        return $http.post(`${global.API_URL}/sme/billDataSourceConfig/uploadBillDataSourceConfig`,params)
    },
    // 上传附件到s3 = > 上传账单上传按钮 弹窗 上传附件地址
    uploadBillDataS3(params){
        return $http.post(`${global.API_URL}/sme/billDataSourceConfig/uploadBillDataS3`,params)
    },
    // 删除同步配置 =》 账单存储桶配置 列表删除
    deleteBilldataSourceConfig(id,params){
        let param = new URLSearchParams();
        param.append(id, params);
        return $http.post(`${global.API_URL}/sme/billDataSourceConfig/deleteBilldataSourceConfig`,param)
    },
    // 删除s3附件 =》 上传账单上传按钮 弹窗 上传附件地址 删除附件
    deleteBillDataS3(params){
        return $http.post(`${global.API_URL}/sme/billDataSourceConfig/deleteBillDataS3`,params)
    },
    // 查询同步记录 =》上传账单 列表同步记录=》分页查询
    selectSyncRecord(params){
        return $http.post(`${global.API_URL}/sme/billDataSourceSyncRecord/selectSyncRecord`,params)
    },
    // 下载上传的原始文件 上传账单-》下载按钮
    downLoadBillDataSourceConfig(id,params){
        let param = new URLSearchParams();
        param.append(id, params);
        return $http.post(`${global.API_URL}/sme/billDataSourceConfig/downLoadBillDataSourceConfig`,param,{
            responseType: 'blob',
            }
            )
    },
    // 以下为账单规则 账单导出接口 1.10.2023


    // ------------------- 账单数据处理
    // 分页查询接口
    queryPagingBillingDataRule(params){
        return $http.post(`${global.API_URL}/sme/billingSourceDataProcessRule/queryPagingBillingDataRule`,params)
    },
    // 删除数据处理规则接口
    deleteDataRule(id,params){
        let param = new URLSearchParams();
        param.append(id, params);
        return $http.post(`${global.API_URL}/sme/billingSourceDataProcessRule/deleteDataRule`,param)
    },
    // 操作日志接口
    queryOperationLogsbillingSourceDataProcessRule(id,params){
        let param = new URLSearchParams();
        param.append(id, params);
        return $http.post(`${global.API_URL}/sme/billingSourceDataProcessRule/queryOperationLogs`,param)
    },

    // 添加规则页面的账单数据源下拉框  这里接口地址需要修改
    queryBillingAccountByCompanyId(params){
        return $http.post(`${global.API_URL}/sme/account/queryBillingAccountByCompanyId`,params);
    },

    // 标签规则下拉框
    queryBillingTagRule(params){
        return $http.post(`${global.API_URL}/sme/billingSourceDataProcessRule/queryBillingTagRule`,params)
    },

    // 规则名称去重校验接口
    duplicateCheckSourceDataProcessRule(params){
        return $http.post(`${global.API_URL}/sme/billingSourceDataProcessRule/duplicateCheck`,params)
    },

    // 添加规则 编辑规则  确定接口
    addOrUpdateDataRule(params){
        return $http.post(`${global.API_URL}/sme/billingSourceDataProcessRule/addOrUpdateDataRule`,params)
    },
    // 云平台下拉框
    queryCloudPlatforms(){
        return $http.post(`${global.API_URL}/sme/billingSourceDataProcessRule/queryCloudPlatforms`)
    },
    // 查询标签规则详情
    getBillingDataRuleById(id,params){
        let param = new URLSearchParams();
        param.append(id, params);
        return $http.post(`${global.API_URL}/sme/billingSourceDataProcessRule/getBillingDataRuleById`,param)
    },

    // --------------------- 账单标签处理
    // 账单标签规则分页查询
    queryPagingBillingTagRule(params){
        return $http.post(`${global.API_URL}/sme/billingTagProcessRule/queryPagingBillingTagRule`,params)
    },
    // 删除分账账单标签规则
    deleteTagRule(id,params){
        let param = new URLSearchParams();
        param.append(id, params);
        return $http.post(`${global.API_URL}/sme/billingTagProcessRule/deleteTagRule`,param)
    },

    // 操作日志接口 后端接口还没改好
    queryOperationLogs(id,params){
        let param = new URLSearchParams();
        param.append(id, params);
        return $http.post(`${global.API_URL}/sme/billingTagProcessRule/queryOperationLogs`,param)
    },

    // 添加 编辑 标签规则确定接口
    addOrUpdateTagRule(params){
        return $http.post(`${global.API_URL}/sme/billingTagProcessRule/addOrUpdateTagRule`,params)
    },
    // 规则名称去重校验接口
    duplicateCheckTagProcessRule(params){
        return $http.post(`${global.API_URL}/sme/billingTagProcessRule/duplicateCheck`,params)
    },
    // 查询标签规则详情
    getBillingTagRuleById(id,params){
        let param = new URLSearchParams();
        param.append(id, params);
        return $http.post(`${global.API_URL}/sme/billingTagProcessRule/getBillingTagRuleById`,param)
    },



    // 以下为账单导出接口

    // 导出记录
    // 分页查询接口
    queryPagingBillingExportRecord(params){
        return $http.post(`${global.API_URL}/sme/billingExportRecord/queryPagingBillingExportRecord`,params)
    },
    // 下载接口  responseType:'blob' 解决文件打不开问题
    downLoadBilling(id,params){
        let param = new URLSearchParams();
        param.append(id, params);
        return $http.post(`${global.API_URL}/sme/billingDownloadRecord/downLoadBilling`,param,{
            responseType:'blob'
        })
    },
    // 下载记录分页接口
    queryPagingDownLoadRecord(params){
        return $http.post(`${global.API_URL}/sme/billingDownloadRecord/queryPagingDownLoadRecord`,params)
    },
    // 导出模板的下拉框接口
    queryBillingTemplate(params){
        return $http.post(`${global.API_URL}/sme/billingExportRecord/queryBillingTemplate`,params)
    },
    // 根据导出模板和账单时间范围返回tag字段接口
    queryTagByTemplateIdAndDate(params){
        return $http.post(`${global.API_URL}/sme/billingExportRecord/queryTagByTemplateIdAndDate`,params)
    },
    // 列表字段返回接口
    queryStandardColumnBox(){
        return $http.post(`${global.API_URL}/sme/billingExportTemplate/queryStandardColumnBox`)
    },
    // 导出记录名称去重校验接口
    duplicateCheckbillingExportRecord(params){
        return $http.post(`${global.API_URL}/sme/billingExportRecord/duplicateCheck`,params)
    },
    // 导出确认接口
    exportBilling(params){
        return $http.post(`${global.API_URL}/sme/billingExportRecord/exportBilling`,params)
    },
    // 统计字段返回接口
    queryCollectColumnBox(){
        return $http.post(`${global.API_URL}/sme/billingExportTemplate/queryCollectColumnBox`)
    },
    // 导出状态
    queryExportStatus(){
        return $http.post(`${global.API_URL}/sme/billingExportRecord/queryExportStatus`)
    },



    // 导出模板
    // 分页查询接口
    queryPagingBillingExportTemplate(params){
        return $http.post(`${global.API_URL}/sme/billingExportTemplate/queryPagingBillingExportTemplate`,params)
    },
    // 删除导出模板接口
    deleteExportTemplate(id,params){
        let param = new URLSearchParams();
        param.append(id, params);
        return $http.post(`${global.API_URL}/sme/billingExportTemplate/deleteExportTemplate`,param)
    },
    // 操作日志
    queryOperationLogsbillingExportTemplate(id,params){
        let param = new URLSearchParams();
        param.append(id, params);
        return $http.post(`${global.API_URL}/sme/billingExportTemplate/queryOperationLogs`,param)
    },
    // 模板名称去重校验接口
    duplicateCheckbillingExportTemplate(params){
        return $http.post(`${global.API_URL}/sme/billingExportTemplate/duplicateCheck`,params)
    },
    // 添加模板确认接口
    billingExportTemplateConfirm(params){
        return $http.post(`${global.API_URL}/sme/billingExportTemplate/addOrUpdateBillingExportTemplate`,params)
    },
    // 查询导出模板详情
    getBillingTemplateById(id,params){
        let param = new URLSearchParams();
        param.append(id, params);
        return $http.post(`${global.API_URL}/sme/billingExportTemplate/getBillingTemplateById`,param)
    },
}

export default originalBillEntry;


// WEBPACK FOOTER //
// ./src/api/originalBillEntry.js